import { useLazyQuery } from '@apollo/client'
import { gql } from '@apollo/client/core'

import { MEDICAL_HISTORY_ATTACHMENTS_SECTION_FIELDS } from '../fragments/medicalHistoryAttachmentsSections'

export const FETCH_MEDICAL_HISTORY_ATTACHMENTS_SECTIONS = gql`
  ${MEDICAL_HISTORY_ATTACHMENTS_SECTION_FIELDS}
  query MedicalHistoryAttachmentSections(
    $patientId: ID!
    $from: DateTime
    $to: DateTime
  ) {
    attachments: medicalHistorySection(
      input: {
        patientId: $patientId
        from: $from
        to: $to
        sectionType: ATTACHMENTS
      }
    ) {
      __typename
      id
      name
      checked
      section
      ... on MedicalHistoryAttachmentsSection {
        ...MedicalHistoryAttachmentsSectionFields
      }
    }
  }
`

export const FETCH_MEDICAL_HISTORY_LAB_ATTACHMENTS_SECTIONS = gql`
  ${MEDICAL_HISTORY_ATTACHMENTS_SECTION_FIELDS}
  query MedicalHistoryLabAttachmentSections(
    $patientId: ID!
    $from: DateTime
    $to: DateTime
  ) {
    labs: medicalHistorySection(
      input: { patientId: $patientId, from: $from, to: $to, sectionType: LABS }
    ) {
      __typename
      id
      name
      checked
      section
      ... on MedicalHistoryAttachmentsSection {
        ...MedicalHistoryAttachmentsSectionFields
      }
    }
  }
`

export const FETCH_MEDICAL_HISTORY_IMAGING_ATTACHMENTS_SECTIONS = gql`
  ${MEDICAL_HISTORY_ATTACHMENTS_SECTION_FIELDS}
  query MedicalHistoryImagingAttachmentSections(
    $patientId: ID!
    $from: DateTime
    $to: DateTime
  ) {
    imaging: medicalHistorySection(
      input: {
        patientId: $patientId
        from: $from
        to: $to
        sectionType: IMAGING
      }
    ) {
      __typename
      id
      name
      checked
      section
      ... on MedicalHistoryAttachmentsSection {
        ...MedicalHistoryAttachmentsSectionFields
      }
    }
  }
`

export const useMedicalHistoryAttachmentsSectionsLazyQuery = () =>
  useLazyQuery(FETCH_MEDICAL_HISTORY_ATTACHMENTS_SECTIONS)

export const useMedicalHistoryLabAttachmentsSectionsLazyQuery = () =>
  useLazyQuery(FETCH_MEDICAL_HISTORY_LAB_ATTACHMENTS_SECTIONS)

export const useMedicalHistoryImagingAttachmentsSectionsLazyQuery = () =>
  useLazyQuery(FETCH_MEDICAL_HISTORY_IMAGING_ATTACHMENTS_SECTIONS)
